import { Button, Container, Form } from 'react-bootstrap';
import { useState } from 'react';

import { db } from '../../ReactNative/firebase';
import { child, get, ref } from 'firebase/database';
import { useNavigate } from 'react-router-dom';

const RRHome = () => {
    const [name, setName] = useInput({type: 'text'})
    const [email, setEmail] = useInput({ type: 'email'})
    const navigate = useNavigate()

    function useInput({ type }) {
        const [value, setValue] = useState("");
        const input = <input value={value} onChange={e => setValue(e.target.value)} type={type} />
        return [value, input];
    }

    const startQuiz = (e) => {
        e.preventDefault();
        // if (sessionStorage.getItem('TriviaEmail')) {
        //     alert("Seems like you've taken the quiz already. If you want to take it again, please see celebrants!")
        // }
        // if (sessionStorage.getItem('TriviaName')) {
        //     alert("Seems like you've taken the quiz already. If you want to take it again, please see celebrants!")
        // }
        if (!name) {
            alert("Please type your name first.")
        } else if(!email) {
            alert("Please type your email, too.")
        } else {
            const dbRef = ref(db)
            get(child(dbRef,'RRTriviaScoreboard/')).then(snap => {
                var foundEmail = false
                for (var i=0; i< snap.size; i++) {
                    if (email.toLowerCase() === snap.val()[i].email.toLowerCase()) {
                        // console.log('Found email')
                        alert("Seems like you've taken the quiz already with this email. If you want to take it again, please see celebrants!")
                        foundEmail = true
                    }
                }
                if (!foundEmail) {
                    sessionStorage.setItem('TriviaEmail',email)
                    sessionStorage.setItem('TriviaName',name)
                    navigate('/QuizTrivias/RusselRica/RRTrivia')
                }
            })

        }
    }

    return (
            <>
                <Container className="keiki-party RRTriviaBackground">
                        <h1 className='custom-banner'>Welcome to Russel and Rica's Trivia!</h1>
                <div className='text-center'>
                    <div className='Apps'>
                    <Form onSubmit={startQuiz}>
                    <h3 className='fontBackground'>Before taking it, please fill up info:</h3>
                    <Form.Label className='fontBackground'>Name:</Form.Label>
                        {setName}
                    <br />
                    <br />
                    <Form.Label className='fontBackground'>Email:</Form.Label>
                        {setEmail}
                    <br />
                    <br />
                        <Button type="submit" value="startQuiz" className="btnSizeUp" disabled= {false} variant="info">Start Trivia</Button>
                    </Form>
                    </div>
                </div>
                <div className='row'>
                <div className='usedImageStyle'>
                    <a href="http://www.freepik.com">Designed by coolvector / Freepik</a>
                </div>
                    
                </div>
                
                </Container>
            </>
    )
}

export default RRHome;